import { styled } from '@linaria/react';

import { ContentContainer } from '~shared/ui/atoms';
// eslint-disable-next-line no-restricted-imports
import { MqMobileOnly, MqTablet } from '~theme/media';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding-bottom: calc(var(--safe-bottom) + 4.8rem);
	contain: unset;

	${MqMobileOnly} {
		&:has(+ .chat-container) {
			display: none;
			content-visibility: hidden;
		}
	}

	${MqTablet} {
		padding-bottom: calc(
			var(--safe-bottom) + 3.6rem
		); /* on safari desktop footer is too low. known issue, DO NOT FIX */
		contain: size;
	}
`;

export const SiteFooter = styled(ContentContainer)`
	padding-top: 1.6rem;
	margin-top: auto;

	${MqTablet} {
		& > p {
			justify-content: flex-start;
			text-align: left;
		}
	}
`;

export const Container = styled.div`
	min-height: 0;
	flex: 1;
	padding: 0 var(--screen-padding);
	margin: 0 calc(var(--screen-padding) * -1);
	overflow-anchor: none;
	overflow-x: auto;
	scroll-behavior: smooth;

	${MqTablet} {
		padding: 6px 0 0;
		margin: 0 0 0 calc(var(--screen-padding) * -1);
	}
`;
